import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField, Chip } from "@mui/material";

function AdmittedBatchSelect({ admittedBatches, form, setForm, errors }) {
  // Ensure form.admitted_batches is always an array of strings
  const selectedIds = useMemo(() => {
    if (!form.admitted_batches) return [];
    if (Array.isArray(form.admitted_batches)) return form.admitted_batches.map(String);
    return form.admitted_batches.toString().split(",").map(String);
  }, [form.admitted_batches]);

  // Map selectedIds to objects from admittedBatches
  const selectedOptions = useMemo(() => {
    return admittedBatches.filter((batch) =>
      selectedIds.includes(batch.admittedbatch_id.toString())
    );
  }, [admittedBatches, selectedIds]);

  return (
    <Autocomplete
      multiple
      options={admittedBatches}
      getOptionLabel={(option) => option?.admittedbatch || ""}
      value={selectedOptions} // Must be objects from options
      isOptionEqualToValue={(option, value) =>
        option.admittedbatch_id.toString() === value.admittedbatch_id.toString()
      }
      onChange={(event, newValue) => {
        setForm({
          ...form,
          admitted_batches: newValue.map((v) => v.admittedbatch_id.toString()),
        });
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={option.admittedbatch_id}
            label={option.admittedbatch}
            {...getTagProps({ index })}
            color="primary"
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Admitted Batches"
          placeholder="Select Multiple Admitted Batches for Supply Exam"
          error={!!errors?.admitted_batches}
          helperText={errors?.admitted_batches}
        />
      )}
    />
  );
}

AdmittedBatchSelect.propTypes = {
  admittedBatches: PropTypes.arrayOf(
    PropTypes.shape({
      admittedbatch_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      admittedbatch: PropTypes.string.isRequired,
    })
  ).isRequired,
  form: PropTypes.shape({
    admitted_batches: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
      PropTypes.string,
    ]),
  }).isRequired,
  setForm: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    admitted_batches: PropTypes.string,
  }),
};

export default AdmittedBatchSelect;
